import type { DSLValueLegacy, SubjectVariableLegacy } from '@verantos-dev/types-cohorts';

import { transformSubjectVariableToDsl } from './transformSubjectVariableToDsl';

/**
 *  This function takes in an array of subject variables and returns an array of DSL queries for the cohort definition.
 *
 * @param subjectVariables - The subject variables to transform to DSL queries
 * @returns {DSLValueLegacy[]} - The cohort definition DSL queries
 */
export const transformSubjectVariablesToDsl = (
  subjectVariables: SubjectVariableLegacy[]
): DSLValueLegacy[] => {
  return subjectVariables.map((subjectVariable) => transformSubjectVariableToDsl(subjectVariable));
};
